var exports = {
  "Vf": "MessageReactions.module__reactionsGrid___cjlDZD",
  "RW": "MessageReactions.module__reactionContainer___cjlDZD",
  "sU": "MessageReactions.module__reactionButton___cjlDZD",
  "I1": "MessageReactions.module__reactionMe___cjlDZD",
  "iX": "MessageReactions.module__reactionInner___cjlDZD",
  "Zg": "MessageReactions.module__emoji___cjlDZD",
  "Ps": "MessageReactions.module__countWrapper___cjlDZD",
  "lG": "MessageReactions.module__reactionContainerDisabled___cjlDZD",
  "II": "MessageReactions.module__reactionButtonDisabled___cjlDZD",
  "Go": "MessageReactions.module__reactionPickerButton___cjlDZD",
  "SD": "MessageReactions.module__reactionPickerButtonActive___cjlDZD",
};

module.exports = exports;
